import React from 'react';
import './HomeDashboard.scss'; // Importing the SCSS for styles
import  FormComponent from './FormComponent';

interface HomeDashboardProps {
    itemSize?: number;
}

class HomeDashboard extends React.Component<HomeDashboardProps> {
    render() {

        return (
            <div className="justify-content-center dashboard-audit">
                <FormComponent />
                {/* <div className="alert alert-warning mt-2" role="alert">
                    ⚠️ Note: WorkJam will soon be unavailable. Please install the new app, OnTheJob, to continue using the Callout app.
                </div> */}
            </div>
        );
    }
}

export default HomeDashboard;
